module.exports = __webpack_public_path__ + "static/media/Birthday_girl.a992fbfe.svg";